(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/middlewares/containers-middleware.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/middlewares/containers-middleware.js');

'use strict';

const {
  asyncDrawsApi,
  asyncJackpotApi
} = svs.numbergames.draws;
const apiCalls = svs.numbergames.fractiongames.api_calls;
const {
  hasPassedGenereateEndTime
} = svs.numbergames.fractiongames.utils;
const {
  actions,
  ACTION_TYPES: {
    CONTAINER_ADDED,
    CONTAINER_REMOVED,
    GAME_GENERATED,
    GAME_SHARE_SOLD
  }
} = svs.numbergames.fractiongames.redux.slices.containers;
const containersMiddleware = store => next => {
  const getContainer = containerId => store.getState().containers[containerId];
  const updateContainer = async action => {
    let container = await apiCalls.fetchActivatedDraw(action.activatedDrawId);
    if (container) {
      await asyncDrawsApi.firstPlayableDraw(container.productId);
      await asyncJackpotApi.jackpot(container.productId);
      container = apiCalls.mapContainer(container);
      store.dispatch(actions.gameFetched(container));
    }
  };
  const removeContainer = async action => {
    const containers = await apiCalls.fetchContainers();
    if (containers) {
      let container = containers.find(container => container.containerId === action.containerId);
      if (container) {
        container = apiCalls.mapContainer(container);
        store.dispatch(actions.gameFetched(container));
      } else {
        next(action);
      }
    }
  };
  return action => {
    var _container;
    let container;
    switch (action.type) {
      case CONTAINER_ADDED:
        next(action);
        updateContainer(action);
        break;
      case GAME_GENERATED:
        next(action);
        container = getContainer(action.containerId);
        if (!((_container = container) !== null && _container !== void 0 && _container.buyinCloseTime)) {
          updateContainer(action);
        }
        break;
      case GAME_SHARE_SOLD:
        next(action);
        container = getContainer(action.containerId);
        if (action.soldShares === container.totalShares && hasPassedGenereateEndTime(container)) {
          store.dispatch(actions.containerClosed(action.containerId));
        }
        break;
      case CONTAINER_REMOVED:
        {
          removeContainer(action);
          break;
        }
      default:
        next(action);
    }
  };
};
svs.numbergames.fractiongames.redux.middlewares.containersMiddleware = containersMiddleware;

 })(window);